
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2(308|516|887)|59(28|66)|6(017|418|910)|8(010|124|544|867)|7(7(28|52|77)|325|431|483)|3(72[24]|552)|9(252|397|772)|1979|4434)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
